module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CdFEDZ/images/cover.jpg?1738810476224",
      "alt": "This image is the cover for the book Simple Whatnots IV"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Simple Whatnots IV\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Create charming small quilts that will brighten up any space Best-selling author Kim Diehl presents the fourth and final installment of her Simple Whatnots series, unveiling a fresh collection of 19 small, scrappy projects. Kim continues to share her insightful Extra Snippet tips, decorating ideas, and the advantages of compact projects. The projects showcase Kim’s distinctive designs using invisible machine appliqué and wool appliqué techniques. Encouraging you to explore your scrap baskets, Kim continues to teach you how to use triangle squares, flying geese, stars, and more to create uniquely captivating small quilts for charming home decor. Best-selling author and fabric designer Kim Diehl shares instructions for 19 fun-to-complete quilts Create small yet charming quilts to enhance your home decor, with dozens of charming photographs offering inspiration and displaying ideas The fourth book in her best-selling Simple quilting series")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kim Diehl\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kim Diehl fell in love with a sampler quilt pattern in the late 1990s, taught herself the steps needed to do the project, and became smitten with quiltmaking. Winning a national contest turned Kim's life down an unexpected path, and her new-found hobby quickly blossomed into a full-time career. She lives in Pocatello, Idaho. Find her on Instagram @kim_diehl_quilts.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Published by C&T Publishing, Inc.,\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0